import React, { useState } from "react";

function Modal({ isOpen, onClose, onAddData }) {
  const [title, setTitle] = useState("");
  const [author, setAuthor] = useState("");
  const [genre, setGenre] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();

    onAddData({ title, author, genre });

    setTitle("");
    setAuthor("");
    setGenre("");
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div style={overlayStyle}>
      <div style={modalStyle}>
        <h2 style={{ color: "#2c3e50" }}>Add New Book</h2>
        <form onSubmit={handleSubmit}>
          <input
            style={inputStyle}
            type="text"
            placeholder="Book Title"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            required
          />
          <input
            style={inputStyle}
            type="text"
            placeholder="Author"
            value={author}
            onChange={(e) => setAuthor(e.target.value)}
            required
          />
          <input
            style={inputStyle}
            type="text"
            placeholder="Genre"
            value={genre}
            onChange={(e) => setGenre(e.target.value)}
            required
          />
          <br />
          <button style={submitButton} type="submit">
            Add Book
          </button>
          <button
            type="button"
            onClick={onClose}
            style={cancelButton}
          >
            Cancel
          </button>
        </form>
      </div>
    </div>
  );
}

const overlayStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  backgroundColor: "rgba(0,0,0,0.3)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};

const modalStyle = {
  backgroundColor: "#fff9db", 
  padding: "30px",
  borderRadius: "20px",
  width: "320px",
  textAlign: "center",
  boxShadow: "0 5px 20px rgba(0,0,0,0.1)",
  border: "1px solid #000000"
};

const inputStyle = {
  width: "100%",
  padding: "4px",
  margin: "8px 0",
  borderRadius: "15px",
  border: "3px solid #ffd6e0",
};

const submitButton = {
  backgroundColor: "#bde0fe", 
  color: "#333",
  padding: "8px 14px",
  border: "1px solid #000000",
  borderRadius: "15px",
  cursor: "pointer",
  marginRight: "8px",
};

const cancelButton = {
  backgroundColor: "#ffc8dd", 
  color: "#333",
  padding: "8px 14px",
  border: "1px solid #000000",
  borderRadius: "15px",
  cursor: "pointer",
};

export default Modal;